import { render, staticRenderFns } from "./overview.vue?vue&type=template&id=bed47b40&"
import script from "./overview.vue?vue&type=script&lang=ts&"
export * from "./overview.vue?vue&type=script&lang=ts&"
import style0 from "./overview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports